<template>
  <div style="font-size: 0px">
    <div class="container">
      <el-image style="width: 100%; height: 100%" :src="img" fit="contain"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Buy',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      clientWidth: 0,
    }
  },

  computed: {
    img() {
      let pic = ''
      if (this.clientWidth > 768) {
        pic = require('@/assets/images/p-solution.jpg')
      } else {
        pic = require('@/assets/images/m-solution.jpg')
      }
      return pic
    },
  },

  watch: {},

  created() {},

  mounted() {
    this.clientWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.clientWidth = document.body.clientWidth
      })()
    }
  },

  destroyed() {},

  methods: {},
}
</script>

<style lang="less" scoped></style>
